import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AIVideo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M3 0.5L3.50893 2.12411L5.13304 2.63304L3.50893 3.14196L3 4.76607L2.49107 3.14196L0.866964 2.63304L2.49107 2.12411L3 0.5Z"
        fill={color}
      />
      <path
        d="M7.07501 14.175V5.175M11.875 14.175V5.175M4.675 9.675H14.275M4.675 7.275H7.075M11.875 7.275H14.275M4.675 12.075H7.075M11.875 12.075H14.275M4.675 12.675L4.675 6.675C4.675 5.6809 5.4809 4.875 6.475 4.875L12.475 4.875C13.4691 4.875 14.275 5.6809 14.275 6.675V12.675C14.275 13.6691 13.4691 14.475 12.475 14.475H6.475C5.4809 14.475 4.675 13.6691 4.675 12.675Z"
        stroke={color}
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default AIVideo
